import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { setTheme, resolvedTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="icon"
      className="rounded-full h-8 w-8 sm:h-9 sm:w-9 p-0 inline-flex items-center justify-center shrink-0 cursor-pointer focus:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-transparent hover:bg-muted/60 transition-transform active:scale-95"
      onClick={(e) => {
        setTheme(resolvedTheme === "light" ? "dark" : "light");
        (e.currentTarget as HTMLElement).blur();
      }}
    >
      <Sun className="h-4 w-4 sm:h-5 sm:w-5 rotate-0 scale-100 transition-all text-amber-500 dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 sm:h-5 sm:w-5 rotate-90 scale-0 transition-all text-slate-300 dark:rotate-0 dark:scale-100" />
      <span className="sr-only">{t('common.toggle_theme', 'Changer le thème')}</span>
    </Button>
  );
}
